export default __webpack_public_path__ + "static/media/brain.99a70507.svg";